import React, { useEffect } from 'react'
import { Select } from 'antd'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react-lite'
import { useStores } from '../../cls/stores/MobXProvider'
import { actLoadUsers } from '../../stores/ui-lst-users/actions'
/**
 * SelectUsers renders a user multi-select dropdown based on a specified type.
 * It loads users on mount and builds options from the store.
 *
 * @component
 * @param {Object} props
 * @param {'clients'|'team'}      props.type      The category of users to select: 'clients' or 'team'.
 * @param {string|string[]}       [props.value]  The currently selected user ID(s).
 * @param {function}              props.onChange Callback invoked when selection changes.
 * @param {...any}               [props]        Additional Ant Design Select props.
 * @returns {JSX.Element} The rendered Select component with user options.
 */
export const SelectUsers = observer(
	({ type, value = [], onChange, ...props }) => {
		const { users, uiLstUsers } = useStores()
		const { loggedInUser } = users

		//  Load all users
		useEffect(() => {
			actLoadUsers().catch(console.error)
		}, [loggedInUser])

		// build dynamic idType based on option type
		const idsType =
			type == 'clients' ? 'clientIds' : type == 'team' ? 'teamIds' : ''

		// Select options
		const options = uiLstUsers?.[idsType]?.map((id) => {
			const user = users.requireUserById(id)

			// Build the label based on user details
			const label = [
				user?.email && `${user?.email}`,
				(user?.name || user?.businessName) && ' (', // wrapper
				user?.name && `${user?.name}`,
				user?.name && user?.businessName && ' - ', // separator
				user?.businessName && `${user?.businessName}`,
				(user?.name || user?.businessName) && ')' // wrapper
			]
				.filter(Boolean) // Filter out any false values
				.join('') //Join the roles with a comma

			// return option
			return {
				value: id,
				label: label || id
			}
		})

		return (
			<Select
				value={value}
				onChange={onChange}
				filterOption={false}
				options={options}
				{...props}
			/>
		)
	}
)

SelectUsers.propTypes = {
	type: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	onChange: PropTypes.func
}
